/**
 * Rich Text — TOC builder
 * -----------------------
 * Auto-builds a sidebar table of contents from <h2> elements in the page
 * content, and highlights the active item as the user scrolls.
 *
 * Activates on pages with .has-toc + a [data-rich-toc] sidebar in the DOM.
 * If no H2s exist in the content, the sidebar stays hidden and the layout
 * falls back to a single centered column.
 */
(function () {
    'use strict';

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    function init() {
        var page    = document.querySelector('.rich-text-page.has-toc');
        if (!page) return;

        var toc     = page.querySelector('[data-rich-toc]');
        var list    = page.querySelector('[data-rich-toc-list]');
        var select  = page.querySelector('[data-rich-toc-select]');
        var content = page.querySelector('[data-rich-content]');
        if (!toc || !list || !content) return;

        var headings = content.querySelectorAll('h2');
        if (!headings.length) return;        // no H2s → leave hidden

        // Slugify a heading's text for an id (only used if WP didn't already
        // give the heading an id).
        function slugify(text) {
            return text
                .toLowerCase()
                .replace(/[^\w\s-]/g, '')
                .trim()
                .replace(/\s+/g, '-')
                .substring(0, 60);
        }

        var items = [];
        headings.forEach(function (h, i) {
            if (!h.id) {
                var slug = slugify(h.textContent || ('section-' + i));
                if (document.getElementById(slug)) slug += '-' + i;
                h.id = slug;
            }
            var label = h.textContent || ('Section ' + (i + 1));

            // Desktop: list item with link
            var li = document.createElement('li');
            var a  = document.createElement('a');
            a.href = '#' + h.id;
            a.textContent = label;
            a.addEventListener('click', function (e) {
                e.preventDefault();
                history.pushState(null, '', '#' + h.id);
                h.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
            li.appendChild(a);
            list.appendChild(li);

            // Mobile: option in the native select
            if (select) {
                var opt = document.createElement('option');
                opt.value = h.id;
                opt.textContent = label;
                select.appendChild(opt);
            }

            items.push({ heading: h, link: a });
        });

        // Handle select change → smooth-scroll to target
        if (select) {
            select.addEventListener('change', function () {
                var id = select.value;
                if (!id) return;
                var target = document.getElementById(id);
                if (!target) return;
                history.pushState(null, '', '#' + id);
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        }

        toc.removeAttribute('hidden');
        page.classList.add('has-toc-items');

        // Active-section highlighting via IntersectionObserver
        if (!('IntersectionObserver' in window)) return;

        // Track which headings are currently above the viewport's
        // "reading line" (~30% from top). The last one above wins.
        var navOffset = 0;
        function syncNavOffset() {
            var v = getComputedStyle(document.documentElement)
                    .getPropertyValue('--site-nav-height').trim();
            navOffset = parseFloat(v) || 80;
        }
        syncNavOffset();
        window.addEventListener('resize', syncNavOffset);

        function updateActive() {
            var line = navOffset + window.innerHeight * 0.2;
            var activeIdx = -1;
            for (var i = 0; i < items.length; i++) {
                var top = items[i].heading.getBoundingClientRect().top;
                if (top <= line) activeIdx = i;
                else break;
            }
            items.forEach(function (it, idx) {
                it.link.classList.toggle('is-active', idx === activeIdx);
            });
            // Keep the mobile select in sync with the active section
            if (select && activeIdx >= 0) {
                var activeId = items[activeIdx].heading.id;
                if (select.value !== activeId) select.value = activeId;
            }
        }

        window.addEventListener('scroll', updateActive, { passive: true });
        window.addEventListener('resize', updateActive);
        updateActive();
    }
})();